import {
  PLACEMENT__BOTTOM_END
} from '../components/Layout/Wrappers/StyledTooltip';
import {
  ENGAGEMENT_MATCH_STRENGTH__NO,
  ENGAGEMENT_MATCH_STRENGTH__STRONG_NO,
  ENGAGEMENT_MATCH_STRENGTH__STRONG_YES,
  ENGAGEMENT_MATCH_STRENGTH__TBD,
  ENGAGEMENT_MATCH_STRENGTH__WEAK_NO,
  ENGAGEMENT_MATCH_STRENGTH__WEAK_YES,
  ENGAGEMENT_MATCH_STRENGTH__YES
} from '../lib/Definition';

const MatchPageUI = {
  SelectedJobExtendedFilter: {
    label: 'Extended Filter',
    title: 'Enable extended filters: Rating and Stages',
    placement: PLACEMENT__BOTTOM_END
  },
  JobsDropdown: {
    label: 'Jobs',
    title: 'Select a similar job to filter candidates matched to that role',
    placement: PLACEMENT__BOTTOM_END,
  },
  // camelcase and start with uppercase to define component dictionaries
  // camelcase and start with lowercase to define key dictionaries and variables
  CardChipBar: {
    JobStatus: {
      jobsPermitted: {
        label: 'Permitted',
        color: colors.red.darker
      },
      jobsPitched: {
        label: 'Awaiting',
        color: colors.red.darker
      },
      jobsDeclined: {
        label: 'Declined',
        color: colors.red.darker
      },
      jobBlackListed: {
        label: 'Blacklisted',
        color: colors.red.darker
      },
      candidateHired: {
        label: 'Hired',
        color: colors.red.darker
      },
      limitedRecruiter: {
        label: 'Limited',
        color: colors.red.darker
      }
    },
    matchType: {
      // The label comes from the tag system -> `matchType`:
      // 1. Recruiter Self Match
      // 2. ML Auto Catch Recruiter Miss
      // 3. Admin Additional Match
      // 4. Admin Back Match
      label: '{{LABEL__TAG__MATCH_TYPE}}',
      color: colors.purple.medium
    },
    OwnerShip: {
      // IF
      // Job is blacklisted
      unavailableToCando: {
        label: 'Do Not Match',
        color: colors.red.common
      },
      // ELSE OR
      ownedByOther: {
        label: 'Owned By Other',
        color: colors.red.common  // TAKEN
      },
      tbdForOther: {
        label: 'TBD for other',
        color: colors.gray.common  // TBD
      },
      ownedByNoOne: {
        label: 'Available',
        color: colors.blue.common  // AVAILABLE
      },
      iAlreadyOwnIt: {
        label: 'Owned',
        color: colors.green.common  // YOUR
      },
      iTbdItWithoutEngagement: {
        label: 'TBD for candidate',
        color: colors.gray.common  // TBD
      },
      // END IF
      priorSubmission: {
        // The label is built based on the calculation of prior submissions:
        // 1. Prior Submission*
        // 2. Prior Submission^
        label: '{{LABEL__CALCULATED__PRIOR_SUBMISSION}}',
        // The color is currently inherited from one of the above cases.
        color: '{{COLOR__CALCULATED__OWNERSHIP}}'
      },
      // The calibration label is built based on `engagement.calibrationStatus`.
      calibration: {
        [ENGAGEMENT_MATCH_STRENGTH__YES]: {
          color: colors.green.medium
        },
        [ENGAGEMENT_MATCH_STRENGTH__WEAK_YES]: {
          color: colors.green.medium
        },
        [ENGAGEMENT_MATCH_STRENGTH__STRONG_YES]: {
          color: colors.green.medium
        },
        [ENGAGEMENT_MATCH_STRENGTH__NO]: {
          color: colors.red.medium
        },
        [ENGAGEMENT_MATCH_STRENGTH__WEAK_NO]: {
          color: colors.red.medium
        },
        [ENGAGEMENT_MATCH_STRENGTH__STRONG_NO]: {
          color: colors.red.medium
        },
        [ENGAGEMENT_MATCH_STRENGTH__TBD]: {
          color: colors.gray.medium
        }
      }
    }
  }
};
export default MatchPageUI;
